import React from "react";
import Layout from "containers/Layout";
import Auth from "hoc/Auth";
import { signIn, signinRedirectCallback } from "../oidc";

export const PrivateRoute = ({ component, ...rest }) => {
  const { token_type } =
    JSON.parse(sessionStorage.getItem("pharmaforce")) || {};
  if (token_type) {
    return <Layout />;
  }
  signinRedirectCallback();
  return <Auth signIn={signIn} />;
};
